module.exports = __webpack_public_path__ + "img/7.a484448e.jpg";